/**
 * Add ability for range input to put it's value into a text field.
 * To use this, simply add .js-number-range to a parent with range and number inputs inside.
 *
 */
const init = function() {
  const rangeFields = document.querySelectorAll('.js-number-range');

  rangeFields.forEach(range => {
    const rangeInput = range.querySelector('input[type="range"]');
    const numberInput = range.querySelector('input[type="number"]');

    if(rangeInput && numberInput) {
      rangeInput.addEventListener('input', e => numberInput.value = e.target.value);
      numberInput.addEventListener('input', e => rangeInput.value = e.target.value);
    }
  });
}

export default {
  init
}
